<template>
  <div class="chkMask">
    <div ref="chkBOx" class="chkBOx" :style="{background: 'url(' + IMG_BASE_URL + 'menuDio.png' + ') no-repeat', backgroundSize: 'contain'}">
      <div class="del" @click="deleteMap()" 
        :style = "{ background: `url(${IMG_BASE_URL}menuDel.png) no-repeat`, backgroundSize: 'contain'}"
        ></div>
      <div class="mark">{{totalScore}}</div>

      <div class="map map1" 
          @click="checkMap()" 
          :dir="dirLang" 
          :style = "{ background: `url(${IMG_BASE_URL}menuBorder.png) no-repeat`, backgroundSize: 'contain'}"
          >
        <span>{{$t('maps')}}</span>
      </div>

      <div class="map description" 
          @click="des()" 
          :dir="dirLang" 
          :style = "{ background: `url(${IMG_BASE_URL}menuBorder.png) no-repeat`, backgroundSize: 'contain'}"
          >
        <span>{{$t('game')}}</span>
      </div>
      <div class="map bgStory " @click="checkBg()" :dir="dirLang" 
          :style = "{ background: `url(${IMG_BASE_URL}menuBorder.png) no-repeat`, backgroundSize: 'contain'}"
          >
        <span>{{$t('bgstory')}}</span>
      </div>
      <div class="map knowledge" @click="getKnowledge()" :dir="dirLang" 
        :style = "{ background: `url(${IMG_BASE_URL}menuBorder.png) no-repeat`, backgroundSize: 'contain'}"
        >
        <span>{{$t('python')}}</span>
      </div>
      <div ref="checkTop" class="demo1" 
        :style = "{ background: `url(${IMG_BASE_URL}choose01.png) no-repeat`, backgroundSize: 'contain'}"
        ></div>
      <div class="demo2" v-show="false" :dir="dirLang">{{txt}}</div>
      <div class="Sbg" v-show="sbgShow"
          :style = "{ background: `url(${IMG_BASE_URL}border01.png) no-repeat`, backgroundSize: 'contain'}"
          ></div>
      <div  class="Sbg border2"  v-if="!sbgShow">
        <!-- 背景故事 preload-->
        <div class="desBg" style='zIndex:12' v-if='videoToshow'>
          <video id="video" preload=metadata controlslist="nodownload" controls
              width="100%" height='100%' style="objectFit:fill;borderRadius: 10px" 
              :src='createURL+"/static/video/"+ lang +"/video01.mp4"' 
              >
          </video>
        </div>
        <div ref="border2" class="desBg" @dblclick='checkBigBg()'>
          <div class="btnBig" @click="checkBigBg()" 
            :style = "{ background: `url(${IMG_BASE_URL}tobig.png) no-repeat`, backgroundSize: 'contain'}"
            ></div>
        </div>
        <div class="desBg02" :style="{background: `url(${IMG_BASE_URL}border03.png) no-repeat`}"></div>
      </div>
      <div class="demo3" >
        <!-- 地图关卡 :interval="5000000" -->
        <el-carousel ref="carousel" trigger="click" :autoplay='false' indicator-position="outside"  arrow="always" v-show="carouselShow" loop='false' @change="changePic">
          <div class="leftArrow" 
            :style = "{ background: `url(${IMG_BASE_URL}left.png) no-repeat`}"
            ></div>
          <div class="rightArrow" 
            :style = "{ background: `url(${IMG_BASE_URL}right.png) no-repeat`}"
            ></div>
          <el-carousel-item  v-for="e in allBgMap.length" :key="e" >
            <div class="horselight01" :class="'HWD'+e">
              <span v-for="item in 10" :key="item" @click="checkPoint(e,item)" @mouseover='seeStyle(e,item)' @mouseleave="leaveStyle(e,item)" ref='smalli' class="smalli">
                <i :style = "{ background: `url(${IMG_BASE_URL}highStar.png) no-repeat`, backgroundSize: 'contain'}"></i>
                <i :style = "{ background: `url(${IMG_BASE_URL}highStar.png) no-repeat`, backgroundSize: 'contain'}"></i>
                <i :style = "{ background: `url(${IMG_BASE_URL}highStar.png) no-repeat`, backgroundSize: 'contain'}"></i>
              {{(e-1)*10 + item}}</span>
            </div>
          </el-carousel-item>
        </el-carousel>
        
      </div>
      <!-- python知识说明 游戏说明 :interval="5000000" -->
      <div class="smallCarousel" v-show="!sbgShow">
        <div class="arrow leftArrow01" 
          :style="{background: `url(${IMG_BASE_URL}leftArrow01.png) no-repeat`, backgroundSize: 'contain'}"
          v-show="preShow"
          @click='pre()'
          ></div>
        <div class="arrow rightArrow01" 
          :style="{background: `url(${IMG_BASE_URL}rightArrow01.png) no-repeat`, backgroundSize: 'contain'}"
          v-show="nextShow" 
          @click='next()'
          ></div>
        <div class="s_carousel">
          <ul ref="refCarousel" id="carousel">
            <li ref="lis01" class="li_carousel" 
                v-if='videoShow' :key="item" 
                @mouseover='seeStyleLi01()' 
                @mouseleave="leaveStyleLi01()" 
                @click="checkLi01()" >
                <span class="li_carousel_span" v-if="chooseMode != '0'" :dir="dirLang">{{$t('background_intro_video')}}</span>
                <span class="li_carousel_span" v-if="chooseMode == '0'" :dir="dirLang">{{$t('blockly_bg_intro_video')}}</span>
            </li>
            <li ref="lis" class="li_carousel" v-for="(item,index) in dataList" :key="item" @mouseover='seeStyleLi(item,index)' @mouseleave="leaveStyleLi(item,index)" @click="checkLi(item,index)" ><span class="li_carousel_span" :dir="dirLang">{{$t('' + item.key)}}</span></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="bigImgs" v-show="bigImgShow">
      <div ref="bigImg" class="bigImg animated fadeIn" @dblclick='delImg()'>
        <div class="delVideo delImg" @click="delImg()" 
          :style = "{ background: `url(${IMG_BASE_URL}delVideo.png) no-repeat`}"
          ></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import store from "../../store";
import HttpService from '../../service/HttpService';
import res from '../../manager/Position'
import AdventureManager from "../../manager/AdventureManager";
import OperateDom from "../../manager/OperateDom";
import Axios from 'axios';
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      carouselShow:true,
      sum:'',
      totalScore:'',
      videoShow:false,
      loading:false,
      screenWidth: '',
      screenHeight: '',
      sbgShow:true,
      videoToshow:false,
      vIndex:0,
      hightIndex:"",
      gameDataList:[],
      dataList:[],
      // lan:'',
      signFlag:'',
      txt:'',
      createURL: process.env.GAME_CREATE_URL,
      IMG_BASE_URL: process.env.IMG_BASE_URL,
      bigImgShow:false,
      itemObj:'',
      videoIndex:0
    }
  },
  mounted(){
    this.lan = AdventureManager.getLanguage();
    this.$i18n.locale = this.lan;
    // 获取元素
    let spans = document.querySelectorAll('.horselight01 span');
    let imgs = document.querySelectorAll('.el-carousel__item')
    // 根据窗口大小适配相应比例
    this.ideResize()
    window.addEventListener('resize',this.ideResize)

    // 获取python或bolckly总共关卡
    let is = Math.ceil(window.bridge.getTotalLevel(0)/10);
    store.state.allBgMap.splice(is,15-is)
    // 渲染所有关卡背景图
    store.state.allBgMap.forEach((element,index) => {
      imgs[index].style.background = 'url(' + element.checkponit01 + ') no-repeat'
    });
    // 获取用户信息
    let checkpointData = store.state.checkpointData;
    // 获取score 组成数组
    if(checkpointData.gameDataList){
      checkpointData.gameDataList.forEach((e,i) =>{
        this.gameDataList.push(e.score)
      })
    }
    // 分数
    this.totalScore = checkpointData.currentScore;
    // 确定所有icon的位置所在
    this.setIcon(spans)

    //获取个人最高关
    let j = checkpointData.currentCheckPointer;
    this.setBg(spans,j)
    var number = ''
    store.state.selectedPoint ?  number = store.state.selectedPoint : number = j
    var index = number.toString().length > 1 ? number.toString().substring(0,number.toString().length-1) : 0;
    if(number.toString().substr(number.toString().length-1,1) == 0) index = number.toString().substring(0,number.toString().length-1) - 1
    if(number == 10) index = 0;
    // 跳到默认关卡界面 this.$refs.carousel.activeIndex = index;
    this.$nextTick(()=>{
      this.nextPic(index)
    })
  },
  methods: {
    //窗口大小变化
    ideResize(){
      // if(!store.state.checkpointShow) return;
      this.screenWidth = document.body.clientWidth;
      this.screenHeight = document.body.clientHeight;

      if(this.screenWidth >= 1440 & this.screenHeight >= 900){
        $(".chkBOx").css({'transform':'scale(1)'});
        $(".bigImg").css({'transform':'translateX(-50%) scale(1)'});
      } else {
        let scale = Math.min(this.screenWidth/1440, this.screenHeight/900);

        $(".chkBOx").css({'transform':`scale(${scale})`});
        $(".bigImg").css({'transform':`translateX(-50%) scale(${scale})`});
      }

      
    },
    // 标题
    changePic(){
      let index = this.$refs.carousel.activeIndex;
      let name;
      if(store.state.chooseMode == '0') name = 'blockly_unit' + (index+1) + '_name';
      else name = 'unit' + (index+1) + '_name'
      if(this.lan == 'he' || this.lan == 'ar'){
        this.txt = this.$t('unit') + (index+1) + ': ' + this.$t(name)
        return
      }
      this.txt = 'Unit '+ (index+1) + ': ' + this.$t(name)
    },
    // ----------地图功能------------
    // 确定所有icon的位置所在
    setIcon(spans){
      let data = res.arr; // 所有关卡位置配置文件获取
      for(var k = 0; k < spans.length; k++){
        if(k < 10) this.layoutIcon(data[0].icon01,spans,0,1+k,store.state.allImageMap.icon1)//第一张图

        if(k > 10 && k <= 20) this.layoutIcon(data[1].icon02,spans,10,k,store.state.allImageMap.icon2) //第2张图

        if(k > 20 && k <= 30) this.layoutIcon(data[2].icon03,spans,20,k,store.state.allImageMap.icon3) //第3张图

        if(k > 30 && k <= 40) this.layoutIcon(data[3].icon04,spans,30,k,store.state.allImageMap.icon4) //第4张图

        if(k > 40 && k <= 50) this.layoutIcon(data[4].icon05,spans,40,k,store.state.allImageMap.icon5) //第5张图

        if(k > 50 && k <= 60) this.layoutIcon(data[5].icon06,spans,50,k,store.state.allImageMap.icon6) //第6张图

        if(k > 60 && k <= 70) this.layoutIcon(data[6].icon07,spans,60,k,store.state.allImageMap.icon7) //第7张图

        if(k > 70 && k <= 80) this.layoutIcon(data[7].icon08,spans,70,k,store.state.allImageMap.icon8) //第8张图

        if(k > 80 && k <= 90) this.layoutIcon(data[8].icon09,spans,80,k,store.state.allImageMap.icon9) //第9张图

        if(k > 90 && k <= 100) this.layoutIcon(data[9].icon10,spans,90,k,store.state.allImageMap.icon10) //第10张图

        if(k > 100 && k <= 110) this.layoutIcon(data[10].icon11,spans,100,k,store.state.allImageMap.icon11) //第11张图

        if(k > 110 && k <= 120) this.layoutIcon(data[11].icon12,spans,110,k,store.state.allImageMap.icon12) //第12张图

        if(k > 120 && k <= 130) this.layoutIcon(data[12].icon13,spans,120,k,store.state.allImageMap.icon13) //第13张图

        if(k > 130 && k <= 140) this.layoutIcon(data[13].icon14,spans,130,k,store.state.allImageMap.icon14) //第14张图

        if(k > 140 && k <= 150) this.layoutIcon(data[14].icon15,spans,140,k,store.state.allImageMap.icon15) //第15张图
      }
    },
    // 当前关卡
    checkPoint(e,item){
      var n = (e-1) * 10 + item;
      let checkpointData = store.state.checkpointData;
      if(checkpointData.currentCheckPointer < n) return;
      AdventureManager.checkPonit(n,'2')
    },
    seeStyleLi(item,index){
      this.setBallStyleBig(this.$refs.lis,index,'1','scale(1.1)')
    },
    seeStyleLi01(){
      OperateDom.setTransition(this.$refs.lis01,'none','1','scale(1.1)')
    },
    leaveStyleLi(item,index){
      this.setBallStyleBig(this.$refs.lis,index,'1','scale(1)')
    },
    leaveStyleLi01(){
      OperateDom.setTransition(this.$refs.lis01,'none','1','scale(1)')
    },
    // 鼠标悬停效果
    seeStyle(e,item){
      var n = (e-1) * 10 + item;
      let checkpointData = store.state.checkpointData;
      if(checkpointData.currentCheckPointer < n) return;
      this.setBallStyleBig($(".smalli"),n-1,'1','scale(1.3)')
    },
    setBallStyleBig(el,index,opacity,transform){
      el[index].style.opacity = opacity;
      el[index].style.transition = 'All .3s ease-in-out';
      el[index].style.transform = transform;
    },
    leaveStyle(e,item){
      var n = (e-1) * 10 + item;
      this.setBallStyleBig($(".smalli"),n-1,'.8','scale(1)')
    },
    // 第n张
    nextPic(num){
      for(var i = 0; i < num; i++){
        this.$refs.carousel.next();
      }
    },
     // 当前关卡高亮
    setHighlight(ele,current,arr){
      let i = 0;
      ele[current].style.background = `url(${this.IMG_BASE_URL}checked.png) no-repeat`;
      i = current.toString().length > 1 ? Number(current.toString().substring(current.toString().length-1)) : current
      arr.forEach((element,index) => {
        ele[current].style.top = Number(arr[i].top) - 54 + 'px'
        ele[current].style.width = '82px';
        ele[current].style.height = '138px'
        ele[current].style.borderRadius = '0'
        ele[current].style.lineHeight = '153px'
        ele[current].querySelectorAll('i')[0].style.display = 'none'
        ele[current].querySelectorAll('i')[1].style.display = 'none'
        ele[current].querySelectorAll('i')[2].style.display = 'none'
      });
    },
    // 布局所有icon
    layoutIcon(arr,ele,num,e,icon){
      arr.forEach((element,index) => {
        let m = num + index
        ele[m].style.top = arr[index].top + 'px'
        ele[m].style.left = arr[index].left + 'px'
      });
    },
    // 评分星星展示
    setBlock(e,i){
      if(this.gameDataList[i] == 1){
        e.querySelectorAll('i')[0].style.display = 'block'
      }else if(this.gameDataList[i] == 2){
        e.querySelectorAll('i')[0].style.display = 'block'
        e.querySelectorAll('i')[1].style.display = 'block'
      }else if(this.gameDataList[i] == 3){
        e.querySelectorAll('i')[0].style.display = 'block'
        e.querySelectorAll('i')[1].style.display = 'block'
        e.querySelectorAll('i')[2].style.display = 'block'
      }
    },
    // 闯过关卡设置背景
    setBg(ele,num){
      for(var i = 0; i < num; i++){
        if(i < 10){ //第一张图
          ele[i].style.background  = 'url(' + store.state.allImageMap.icon1 + ') no-repeat'
          this.setBlock(ele[i],i)
          if(store.state.selectedPoint && store.state.selectedPoint <= 10) this.setHighlight(ele,store.state.selectedPoint-1,res.arr[0].icon01)
          if(!store.state.selectedPoint && num <= 10) this.setHighlight(ele,num-1,res.arr[0].icon01)

        }else if(i > 9 && i < 20){ //第2张图
          ele[i].style.background  = 'url(' + store.state.allImageMap.icon2 + ') no-repeat'
          this.setBlock(ele[i],i)
          if(store.state.selectedPoint && store.state.selectedPoint <= 20  && store.state.selectedPoint > 10) this.setHighlight(ele,store.state.selectedPoint-1,res.arr[1].icon02)
          if(!store.state.selectedPoint && num > 10 && num <= 20) this.setHighlight(ele,num-1,res.arr[1].icon02)

        }else if(i > 19 && i < 30){ //第3张图
          ele[i].style.background  = 'url(' + store.state.allImageMap.icon3 + ') no-repeat'
          this.setBlock(ele[i],i)
          if(store.state.selectedPoint && store.state.selectedPoint <= 30  && store.state.selectedPoint > 20 ) this.setHighlight(ele,store.state.selectedPoint-1,res.arr[2].icon03)
          if(!store.state.selectedPoint && num > 20 && num <= 30) this.setHighlight(ele,num-1,res.arr[2].icon03)

        }else if(i > 29 && i < 40){ //第4张图
          ele[i].style.background  = 'url(' + store.state.allImageMap.icon4 + ') no-repeat'
          this.setBlock(ele[i],i)
          if(store.state.selectedPoint && store.state.selectedPoint <= 40  && store.state.selectedPoint > 30 ) this.setHighlight(ele,store.state.selectedPoint-1,res.arr[3].icon04)
          if(!store.state.selectedPoint && num > 30 && num <= 40)this.setHighlight(ele,num-1,res.arr[3].icon04)

        }else if(i > 39 && i < 50){ //第5张图
          ele[i].style.background  = 'url(' + store.state.allImageMap.icon5 + ') no-repeat'
          this.setBlock(ele[i],i)
          if(store.state.selectedPoint && store.state.selectedPoint <= 50  && store.state.selectedPoint > 40 ) this.setHighlight(ele,store.state.selectedPoint-1,res.arr[4].icon05)
          if(!store.state.selectedPoint && num > 40 && num <= 50) this.setHighlight(ele,num-1,res.arr[4].icon05)

        }else if(i > 49 && i < 60){ //第6张图
          ele[i].style.background  = 'url(' + store.state.allImageMap.icon6 + ') no-repeat'
          this.setBlock(ele[i],i)
          if(store.state.selectedPoint && store.state.selectedPoint <= 60  && store.state.selectedPoint > 50 ) this.setHighlight(ele,store.state.selectedPoint-1,res.arr[5].icon06)
          if(!store.state.selectedPoint && num > 50 && num <= 60) this.setHighlight(ele,num-1,res.arr[5].icon06)

        }else if(i > 59 && i < 70){ //第7张图
          ele[i].style.background  = 'url(' + store.state.allImageMap.icon7 + ') no-repeat'
          this.setBlock(ele[i],i)
          if(store.state.selectedPoint && store.state.selectedPoint <= 70  && store.state.selectedPoint > 60 ) this.setHighlight(ele,store.state.selectedPoint-1,res.arr[6].icon07)
          if(!store.state.selectedPoint && num > 60 && num <= 70) this.setHighlight(ele,num-1,res.arr[6].icon07)

        }else if(i > 69 && i < 80){ //第8张图
          ele[i].style.background  = 'url(' + store.state.allImageMap.icon8 + ') no-repeat'
          this.setBlock(ele[i],i)
          if(store.state.selectedPoint && store.state.selectedPoint <= 80  && store.state.selectedPoint > 70 ) this.setHighlight(ele,store.state.selectedPoint-1,res.arr[7].icon08)
          if(!store.state.selectedPoint && num > 70 && num <= 80) this.setHighlight(ele,num-1,res.arr[7].icon08)

        }else if(i > 79 && i < 90){ //第9张图
          ele[i].style.background  = 'url(' + store.state.allImageMap.icon9 + ') no-repeat'
          this.setBlock(ele[i],i)
          if(store.state.selectedPoint && store.state.selectedPoint <= 90  && store.state.selectedPoint > 80 ) this.setHighlight(ele,store.state.selectedPoint-1,res.arr[8].icon09)
          if(!store.state.selectedPoint && num > 80 && num <= 90) this.setHighlight(ele,num-1,res.arr[8].icon09)

        }else if(i > 89 && i < 100){ //第10张图
          ele[i].style.background  = 'url(' + store.state.allImageMap.icon10 + ') no-repeat'
          this.setBlock(ele[i],i)
          if(store.state.selectedPoint && store.state.selectedPoint <= 100  && store.state.selectedPoint > 90 ) this.setHighlight(ele,store.state.selectedPoint-1,res.arr[9].icon10)
          if(!store.state.selectedPoint && num > 90 && num <= 100) this.setHighlight(ele,num-1,res.arr[9].icon10)

        }else if(i > 99 && i < 110){ //第11张图
          ele[i].style.background  = 'url(' + store.state.allImageMap.icon11 + ') no-repeat'
          this.setBlock(ele[i],i)
          if(store.state.selectedPoint && store.state.selectedPoint <= 110  && store.state.selectedPoint > 100 ) this.setHighlight(ele,store.state.selectedPoint-1,res.arr[10].icon11)
          if(!store.state.selectedPoint && num > 100 && num <= 110)this.setHighlight(ele,num-1,res.arr[10].icon11)

        }else if(i > 109 && i < 120){ //第12张图
          ele[i].style.background  = 'url(' + store.state.allImageMap.icon12 + ') no-repeat'
          this.setBlock(ele[i],i)
          if(store.state.selectedPoint && store.state.selectedPoint <= 120  && store.state.selectedPoint > 110 ) this.setHighlight(ele,store.state.selectedPoint-1,res.arr[11].icon12)
          if(!store.state.selectedPoint && num > 110 && num <= 120) this.setHighlight(ele,num-1,res.arr[11].icon12)

        }else if(i > 119 && i < 130){ //第13张图
          ele[i].style.background  = 'url(' + store.state.allImageMap.icon13 + ') no-repeat'
          this.setBlock(ele[i],i)
          if(store.state.selectedPoint && store.state.selectedPoint <= 130  && store.state.selectedPoint > 120 ) this.setHighlight(ele,store.state.selectedPoint-1,res.arr[12].icon13)
          if(!store.state.selectedPoint && num > 120 && num <= 130) this.setHighlight(ele,num-1,res.arr[12].icon13)

        }else if(i > 129 && i < 140){ //第14张图
          ele[i].style.background  = 'url(' + store.state.allImageMap.icon14 + ') no-repeat'
          this.setBlock(ele[i],i)
          if(store.state.selectedPoint && store.state.selectedPoint <= 140  && store.state.selectedPoint > 130 ) this.setHighlight(ele,store.state.selectedPoint-1,res.arr[13].icon14)
          if(!store.state.selectedPoint && num > 130 && num <= 140) this.setHighlight(ele,num-1,res.arr[13].icon14)

        }else if(i > 139 && i < 150){ //第15张图
          ele[i].style.background  = 'url(' + store.state.allImageMap.icon15 + ') no-repeat'
          this.setBlock(ele[i],i)
          if(store.state.selectedPoint && store.state.selectedPoint <= 150  && store.state.selectedPoint > 140 ) this.setHighlight(ele,store.state.selectedPoint-1,res.arr[14].icon15)
          if(!store.state.selectedPoint && num > 140 && num <= 150) this.setHighlight(ele,num-1,res.arr[14].icon15)
        }
      }
    },
    //关闭关卡
    deleteMap(){
      $(".chkMask").addClass('animated zoomOut')
      setTimeout(()=>{
        store.state.checkpointShow = false
      },500)
    },
    // 地图
    checkMap(){
      $(".demo2").css("opacity",'1')
      this.carouselShow = true;
      this.videoShow = false;
      this.sbgShow = true;
      this.$refs.checkTop.style.top = '331px'
    },
    // ---------------------over--------------------

    //游戏说明
    des(){
      this.dataList = store.state.CommandList;
      // this.dataList = [{id: 1,image: "command_1.png",key: "command_1",level: "1,1"},{id: 2,image: "command_2.png",key: "command_2",level: "2,2"},{id: 3,image: "command_3.PNG",key: "command_3",level: "3,8"}]
      this.itemObj = ''
      $(".rightArrow01").css('opacity','1')
      this.getHightIndex()
      this.$refs.checkTop.style.top = '429px'
      this.signFlag = 1;
      this.carouselShow = false;
      this.videoShow = false;
      this.sbgShow = false;
      this.videoToshow = false;
      this.vIndex = Number(this.hightIndex);
      this.$nextTick( ()=>{
        this.setbgColorli()
        this.$refs.lis[Number(this.hightIndex)].style.background = `url(${this.IMG_BASE_URL}block2.png) no-repeat`;
        this.$refs.border2.style.background = 'url('+ this.IMG_BASE_URL + 'commands/' + this.lan + '/' + this.dataList[this.vIndex].image +')';
        this.$refs.border2.style.backgroundSize = 'contain';

        if(this.vIndex >= this.dataList.length - 3) this.vIndex = this.dataList.length - 3;
        if(this.vIndex < 0) {
          this.vIndex = 0;
          $(".rightArrow01").css('opacity','0')
        }
        this.animate(this.$refs.refCarousel,-240 * this.vIndex,2000)
      })
    },
     //获取闯过最高关
    getHightIndex(){
      this.hightIndex = store.state.checkpointData.currentCheckPointer;
      let levelArr = [],hightArr = [];
      this.dataList.forEach( (e,i) => {
        let index = e.level.split(',')[1];
        levelArr.push(index)
      })
      for(var i in levelArr ){
        if(this.hightIndex <= levelArr[i]){
          hightArr.push(Number(i))
        }
      }
      this.hightIndex = hightArr[0]
    },
    // python知识说明
    getKnowledge(){
      this.dataList = store.state.knowledgeArr;
      this.itemObj = ''
      // this.dataList = [{id: 1,image: "knowledge_1.png",key: "knowledge_1",level: "4,6"}]
      $(".rightArrow01").css('opacity','1')
      this.getHightIndex()
      this.$refs.checkTop.style.top = '529px'
      this.signFlag = 2;
      this.carouselShow = false;
      this.videoShow = false;
      this.sbgShow = false;
      this.videoToshow = false;
      this.vIndex = Number(this.hightIndex);
      this.$nextTick( ()=>{
        this.setbgColorli()
        this.$refs.lis[Number(this.hightIndex)].style.background = `url(${this.IMG_BASE_URL}block2.png) no-repeat`;
        this.$refs.border2.style.background = 'url('+ process.env.IMG_BASE_URL + 'knowledge/' + this.lan + '/' + this.dataList[this.vIndex].image +')';
        this.$refs.border2.style.backgroundSize = 'contain';

        if(this.vIndex >= this.dataList.length - 3) this.vIndex = this.dataList.length - 3
        if(this.vIndex < 0) {
          this.vIndex = 0;
          $(".rightArrow01").css('opacity','0')
        }
        this.animate(this.$refs.refCarousel,-240 * this.vIndex,2000)
        })
    },
    // 背景故事
    checkBg(){
      this.dataList = store.state.StoryIntroList;
      this.$refs.checkTop.style.top = '629px'
      this.carouselShow = false;
      this.sbgShow = false;
      this.videoShow = true;
      this.videoToshow = true;
      this.signFlag = 3
      this.vIndex = 0;
      this.$nextTick( ()=>{
        this.setbgColorli()
        this.$refs.lis01.style.background = `url(${this.IMG_BASE_URL}block2.png) no-repeat`;
        if(this.vIndex >= this.dataList.length - 2) this.vIndex = this.dataList.length - 2
        if(this.vIndex < 0) {
          this.vIndex = 0;
          $(".rightArrow01").css('opacity','0')
        }
        this.animate(this.$refs.refCarousel,-240 * this.vIndex,2000)
      })
      $(".demo2").css("opacity",'0')
    },
    //
    setbgColorli(){
      var li = this.$refs.refCarousel.querySelectorAll("li")
      li.forEach((e,i) =>{
        li[i].style.background = `url(${this.IMG_BASE_URL}block.png) no-repeat`;
      })
    },

    // 上一张
    pre(){
      if(this.vIndex == 0) return;
      this.vIndex--
      this.animate(this.$refs.refCarousel,-240 * this.vIndex,10)
    },
    // 下一张
    next(){
      let index = ''
      if(this.signFlag == 3) index = this.dataList.length - 2;
      else index = this.dataList.length - 3
      if(this.vIndex == index) return;
      this.vIndex++
      this.preShow = true
      this.animate(this.$refs.refCarousel,-240 * this.vIndex,10)
    },
    // 动画函数
    animate(element, target,step1) {
      clearInterval(element.timeId);
      element.timeId = setInterval(function () {
        var current = element.offsetLeft;
        var step = step1;
        step = current > target ? -step : step;
        current += step;
        if (Math.abs(target - current) > Math.abs(step)) {
          element.style.left = current + "px";
        } else {
          clearInterval(element.timeId);
          element.style.left = target + "px";
        }
      }, 10);
    },
    //点击每一个功能说明
    checkLi(item,index){
      let img = ''
      this.itemObj = item;
      if(this.signFlag == 1) img = 'commands'
      if(this.signFlag == 2) img = 'knowledge'
      if(this.signFlag == 3) img = 'story'
      // if(( Number(this.hightIndex) + 1 ) < item.id) return;
      this.setbgColorli()
      this.$refs.lis[item.id - 1].style.background = `url(${this.IMG_BASE_URL}block2.png) no-repeat`;
      this.$refs.border2.style.background = 'url('+ this.IMG_BASE_URL + img + '/' + this.lan + '/' + item.image +')';
      this.$refs.border2.style.backgroundSize = 'cover';
      if(this.signFlag == 3) {
        this.videoToshow = false;
        this.videoIndex = item.id - 1
        this.$refs.lis01.style.background = `url(${this.IMG_BASE_URL}block.png) no-repeat`;
      }
    },
    checkLi01(){
      this.videoShow = true;
      this.videoToshow = true;
      this.$refs.lis01.style.background = `url(${this.IMG_BASE_URL}block2.png) no-repeat`;
      this.$refs.lis[this.videoIndex].style.background = `url(${this.IMG_BASE_URL}block.png) no-repeat`
    },
    checkBigBg(){
      $(".chkBOx").css("opacity",'.3')
      this.bigImgShow = true;
      let zoomRatio = AdventureManager.changeRatio();
      let screenHeight = document.body.clientHeight;
      if((zoomRatio == '150'&&screenHeight < 800) || (zoomRatio == '125'&&screenHeight < 800)){
        $('.bigImg').css({'transform':'translateX(-50%) scale(.6)','top':'-12%'})
      }
      let img = ''
      if(this.signFlag == 1) img = 'commands'
      if(this.signFlag == 2) img = 'knowledge'
      if(this.signFlag == 3) img = 'story'
      if(this.itemObj == '') this.$refs.bigImg.style.background = 'url('+ this.IMG_BASE_URL + img + '/' + this.lan + '/' + this.dataList[this.vIndex].image +')';
      else this.$refs.bigImg.style.background = 'url('+ this.IMG_BASE_URL + img + '/' + this.lan + '/' + this.itemObj.image +') no-repeat';
      this.$refs.bigImg.style.backgroundSize = 'contain';
    },
    delImg(){
      $(".bigImg").addClass("jello")
      setTimeout(()=>{
        this.bigImgShow = false;
        $(".bigImg").removeClass("jello");
        $(".chkBOx").css("opacity",'1');
      },500)
    }
  },
  destroyed () {
    document.removeEventListener('click', this.ideResize)
  },
  computed: {
    ...mapGetters(["curLevelText", "allImageMap",'checkpointShow','allBgMap','knowledgeArr','CommandList','dirLang','lang','chooseMode']),
    preShow:function(){
      if(this.vIndex == 0){
        return false
      }else{
          return true
        }
    },
    nextShow:function(){
      let index = ''
      if(this.signFlag == 3) index = this.dataList.length - 2;
      else index = this.dataList.length - 3
      if(this.vIndex == index){
        return false
      }else{
        return true
      }
    },
    videoShow:function(){
      if(!this.preShow) return false
    },
  },
}
</script>
<style >
.chkMask{
  width:100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0,0,0,.4);
  z-index: 1000;

  display: flex;
  align-items: center;
  justify-content: center;
}

.chkBOx{
  width: 1257px;
  height: 855px;
  position: absolute;
  transform: scale(1)
}

.Sbg{
  width: 790px;
  height: 519px;
  position: absolute;
  top: 240px;
  left: 392px;
}
.mark{
  width: 239px;
  height: 99px;
  position: absolute;
  top: 198px;
  left: 68px;
  text-align: center;
  line-height: 99px;
  font-size: 47px;
  color: #fff;
  font-weight: 700;
  font-family: 'FZCuYuan-M03S';
}
.demo1{
  width: 248px;
  height: 88px;
  position: absolute;
  top: 330px;
  left: 58px;
  cursor: pointer;
}
.down{
  top: 428px;
}
.map{
  width: 246px;
  height: 85px;
  position: absolute;
  top: 332px;
  left: 60px;
  cursor: pointer;
  font-size: 22px;
  color: #fff;
  text-align: center;
  font-weight: 700;
  font-family: 'FZCuYuan-M03S';
  transition: All .1s ease-in-out;
}
.map1:hover,.description:hover,.bgStory:hover,.knowledge:hover{
  transform: scale(1.1);
}
.bgStory{
  top: 629px;
}
.knowledge{
  top:529px;
}
.description{
  top: 430px;
}
.map span{
  width: 246px;
  height: 85px;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.demo2{
  width: 735px;
  height: 46px;
  position: absolute;
  top: 193px;
  left: 424px;
  cursor: pointer;
  color: #ffc63d;
  font-family: 'zihun54hao-xianhei';
	font-size: 28px;
  line-height:46px;
  text-align: center;
  font-weight: 700;
}
.demo3{
  width: 747px;
  height: 473px;
  position: absolute;
  top: 260px;
  left: 418px;
  overflow: hidden;
}

.el-carousel,.el-carousel__container{
  height: 100% !important;
  overflow: hidden;
}
.el-carousel__item div {
  height: 100%;
}
.el-carousel__indicators--outside{
  position: absolute;
  bottom: 10px;
  transform: translateX(-50%);
}
.el-carousel__indicators--outside button{
  height: 10px;
  border-radius: 50%;
  width: 10px;
  background-color: #fff;
}
.del{
  width: 100px;
  height: 93px;
  position: absolute;
  top: 56px;
  left: 1083px;
  transition: All .3s ease-in-out;
  cursor: pointer;
}
.del:hover{
  transform: scale(1.12);
}
.horselight01 span{
	width: 73px;
	height: 92px;
  position: absolute;
  border-radius: 50%;
  font-size: 20px;
  color: #fff;
  line-height: 48px;
  text-align: center;
  font-family: 'DFPHaiBaoW12';
  font-weight: 700;
  cursor: pointer;
  opacity: .8;
}
.horselight01 span i{
  width: 29px;
  height: 28px;
  position: absolute;
  top: 43px;
  left: -2px;
  display: none;
}
.horselight01 span i:nth-child(2){
  top: 47px;
  left: 24px;
}
.horselight01 span i:nth-child(3){
  left: 47px;
}
.el-carousel__arrow{
  top: 52%;
  font-size: 30px;
  color: transparent;
  z-index: 20;
}
.el-carousel__arrow--right{
  right: 6px
}
.el-carousel__arrow--left{
  left: 6px;
}
.leftArrow{
  width: 23px;
  height: 40px;
  position: absolute;
  left: 10px;
  top: 48%;
  z-index: 10;
  cursor: pointer;
  display: block;
}
.rightArrow{
  right: 10px;
  top: 48%;
  z-index: 10;
  width: 23px;
  height: 40px;
  position: absolute;
  cursor: pointer;
  display: block;
}
.el-carousel:hover .rightArrow{
  display: block;
}
.el-carousel:hover .leftArrow{
  display: block;
}
.border2{
  width:786px;
  height:417px;
  left:375px;
  top: 200px;
}
.smallCarousel{
  width: 727px;
  height: 150px;
  position: absolute;
  bottom: 100px;
  left: 400px;

}
.chkMask .arrow{
  width: 34px;
  height: 60px;
  position: absolute;
  top: 30%;
  left: -34px;
  cursor: pointer;
}
.chkMask .rightArrow01{
  left: 101%;
}
.s_carousel{
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;

}
#carousel{
  width: 100000px;
  position: absolute;
  top: 0;
  left: 0;
}
.li_carousel{
  width:220px;
  height:115px;
  float: left;
  margin: 20px 0 0 20px;
  cursor: pointer;
  color: #fff;
  position: relative;
}
.li_carousel_span{
  width:190px;
  height:115px;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  font-size: 20px;
  top: 0;
  left: 0;
  padding: 0 15px;
  line-height: 30px;
}
.desBg{
  position: absolute;
  top: 20px;
  left: 23px;
  border-radius: 10px;
  width: 742px;
  height: 372px;
  font-size: 40px;
  z-index: 10;
  cursor: pointer;
  color: #fff;
}
.desBg02{
  position: absolute;
  top: 271px;
  left: 12px;
  width: 762px;
  height: 122px;
}
.bigImgs{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,.4)
}
.bigImg{
  width: 1484px;
  height: 743px;
  position: absolute;
  top:-5%;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
}
.btnBig{
  width: 53px;
  height: 53px;
  position: absolute;
  right: 2px;
  top: 10px;
  transition: All .3s ease-in-out;
  opacity: .6;
}
.btnBig:hover{
  transform: scale(1.1);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/onlineClass/checkpoint.vue